@if (!isAuthenticated()) {
  <div class="loading-container">
    <dpqa-loading-spinner />
  </div>
}

<router-outlet></router-outlet>
